module.exports = __webpack_public_path__ + "img/Bodice-Back-Jc-Kf-Lb.1c82b305.png";